'use client';

import { useParams } from 'next/navigation';
import { useAtomValue } from 'jotai';
import { isOddsPageLoadingAtom, oddsPageAtom, sideMatchAtom } from '@/atoms/odds-page';
import { useEffect, useState } from 'react';
import { SportMatchModel } from '@nf/types/odds';
import { useAccountInfo } from '@/hooks/query/account';
import { useStreamingStore } from '@/store/streaming';
import { LoadingIcon } from '@/components/icons/svg-icons';
import { VirtualSportMatchPanel } from '../match-panel/matchpanel-virtualsport';
import { SportMatchPanel } from '../match-panel/matchpanel-sport';
import { useTranslations } from 'next-intl';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { Maybe, MaybeMatch } from '@nf/utils-common/fpw/monadic';

export const StreamingPanel = () => {
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const params = useParams();
	const isSingleMatchPage = params.matchId !== undefined;
	const isOddsPageLoading = useAtomValue(isOddsPageLoadingAtom);
	const newSideMatch = useAtomValue(sideMatchAtom) as SportMatchModel;
	const [sideMatch, setSideMatch] = useState<SportMatchModel | undefined>(newSideMatch);
	const [
		setChangeMatchStatus, 
		streamingType
	] = useStreamingStore(state => [
		state.setChangeMatchStatus, 
		state.streamingType
	]);
	
	useEffect(() => {
		// 若開啟streaming狀態則有新的sidematch才更新, 沒有開啟Streaming則不管有無都更新
		const keepStreaming = ['Streaming', 'Streamer'].includes(streamingType) && isSingleMatchPage;
		MaybeMatch(keepStreaming)
			.fold(
				() => setSideMatch(newSideMatch), 
				() => Maybe(newSideMatch).chain(setSideMatch)
			);
	}, [newSideMatch, params.matchId, streamingType]);

	//避免第一場有抓不到streaming的問題
	useEffect(() => {
		sideMatch && setChangeMatchStatus([t('lbl_Streamer'), t.raw('lbl_Source')], sideMatch, true, SiteConfigsData, user);
	}, []);

	useEffect(() => {
		sideMatch && setChangeMatchStatus([t('lbl_Streamer'), t.raw('lbl_Source')], sideMatch, true, SiteConfigsData, user);
	}, [SiteConfigsData, setChangeMatchStatus, sideMatch, sideMatch?.MatchId, streamingType, t, user]);


	return (
		<>
			{
				!isOddsPageLoading ? (
					(sideMatch) ? (
						(Number(params.sport) >= 180 && Number(params.sport) < 200) ? (
							<VirtualSportMatchPanel match={sideMatch} />
						) : (
							<SportMatchPanel match={sideMatch} isAsideLayout={true} device={'desktop'} />
						)
					) : null
				) : (
					<div className="aside-panel aside-panel--video">
						<div className="loading-circle">
							<LoadingIcon />
						</div>
					</div>
				)
			}
		</>
	)
}